import h, { FunctionComponent } from 'preact';
import { useMemo } from 'preact/hooks';
import { BasketItem, DeliveryOption, Surcharge } from '../types';
import BasketTableHeader from './BasketTableHeader';
import BasketTableRow from './BasketTableRow';
import BasketTableSurcharge from './BasketTableSurcharge';
import BasketTableFooter from './BasketTableFooter';

const BasketTable: FunctionComponent<BasketTableProps> = ({ basketItems, surcharges, deliveryOptions, subtotal, subtotalExcludingDelivery, tax, taxExcludingDelivery, total, deliveryOption, deliveryPrice, isProcessing, orderType, onChangeItemQuantity, onRemoveItem }) => {
    const itemCount = useMemo<number>(() => basketItems.reduce((c, bi) => c + bi.quantity, 0), [ basketItems ]);

    return <table class="basket__table w-100" id="js-basket-table">
            <BasketTableHeader />
            <tbody class="basket__body">
            {basketItems.map((basketItem, idx) => (
                <BasketTableRow
                    key={idx + '|' + basketItem.sku}
                    sku={basketItem.sku}
                    productName={basketItem.product_name}
                    url={basketItem.url}
                    colour={basketItem.colour}
                    size={basketItem.size}
                    quantity={basketItem.quantity}
                    unitPrice={basketItem.unit_price}
                    tax={basketItem.tax}
                    subtotal={basketItem.subtotal}
                    total={basketItem.total}
                    error={basketItem.error ?? null}
                    warning={basketItem.surcharge ?? null}
                    multiple={basketItem.multiple}
                    isProcessing={isProcessing}
                    onUpdateQuantity={quantity => onChangeItemQuantity(basketItem, quantity)}
                    onRemove={() => onRemoveItem(basketItem)}
                />
            ))}
            {surcharges.map(surcharge => (
                <BasketTableSurcharge
                    key={surcharge.skus.join('|')}
                    message={surcharge.name}
                    price={surcharge.price}
                    tax={surcharge.tax}
                />
            ))}
            </tbody>
            <BasketTableFooter
                itemCount={itemCount}
                deliveryOptions={deliveryOptions}
                subtotal={subtotal}
                subtotalExcludingDelivery={subtotalExcludingDelivery}
                tax={tax}
                taxExcludingDelivery={taxExcludingDelivery}
                total={total}
                deliveryOption={deliveryOption}
                deliveryPrice={deliveryPrice}
            />
        </table>
    ;
}

interface BasketTableProps {
    basketItems: Array<BasketItem>;
    surcharges: Array<Surcharge>;
    deliveryOptions: Array<DeliveryOption>;
    subtotal: string;
    subtotalExcludingDelivery: string;
    tax: string;
    taxExcludingDelivery: string;
    total: string;
    orderType: string | null;
    deliveryOption: number | null;
    deliveryPrice: string | null;
    isProcessing: boolean;
    onChangeItemQuantity: (item: BasketItem, quantity: number) => void;
    onRemoveItem: (item: BasketItem) => void;
}

export default BasketTable;
